/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutGiftCardController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'GiftCard';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.Loading = false;
            $scope.Control.GiftCard = '';
            $scope.Control.GiftCardAmount = '';
            $scope.Control.Submitted = false;
            $scope.Control.IsValid = true;
            $scope.Control.ResultMessage = '';
            $scope.Control.Result = '';
            $scope.Control.GiftCardRequired = false;
            $scope.Control.GiftCardAmountRequired = false;

            $element.get(0).focus = function () {
                $('input[ng-model="Control.GiftCard"]', $element).focus().select();
                $('input[ng-model="Control.GiftCardAmount"]', $element).focus().select();
            };

            $scope.Control.setGiftCard = function ($event) {

                var $thisGiftCard = angular.element($event.target);
                var $giftCardCode = $thisGiftCard.attr('data-code');

                $scope.Control.GiftCard = $giftCardCode;

                $scope.Control.submit();
            };

            $scope.Control.submit = function () {
                if (!$scope.Control.GiftCard || $scope.Control.GiftCard.trim() == '') {
                    $scope.Control.GiftCardRequired = true;
                } else {
                    $scope.Control.GiftCardRequired = false;
                }

                if (!$scope.Control.GiftCardAmount || $scope.Control.GiftCardAmount.trim() == '') {
                    $scope.Control.GiftCardAmountRequired = true;
                } else {
                    $scope.Control.GiftCardAmountRequired = false;
                } 

                if ($scope.Control.GiftCardRequired || $scope.Control.GiftCardAmountRequired)
                    return;

                $scope.Control.Loading = true;

                var submittedGiftCardName = $scope.Control.GiftCard;

                var args = {
                    code: $scope.Control.GiftCard,
                    amount: $scope.Control.GiftCardAmount
                };

                ControlService.invokeCheckout($scope, $element, 'SetGiftCard', args).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.IsValid = result.Success;
                    $scope.Control.Result = result.Code;
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;
                    $scope.Control.Loading = false;
                    $scope.setControlValue(controlName, $scope.Control.GiftCard);

                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });
                    $scope.Control.Loading = false;

                    if ($scope.Control.IsValid) {
                        $scope.Control.Submitted = false;
                        $scope.Control.GiftCard = '';
                        $scope.Control.GiftCardAmount = '';
                        setTimeout(function () {
                            $.fancybox.close();
                        }, 800);
                        /* Track Discount GiftCard */
                        if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                            if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                                fbq('trackCustom', 'DiscountGiftCard', { discount: submittedGiftCardName });
                            }
                        } 
                        /* END Track Discount GiftCard */
                    } else {
                        $scope.Control.Submitted = true;
                    }

                }, function (ex) {
                    console.log(ex);
                    $scope.Control.Submitted = true;
                    $scope.Control.Loading = false;
                    $scope.Control.IsValid = false;
                    $scope.Control.Result = 'CartGiftCard_GenericError';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.setControlValue(controlName, '');

                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });
                    $scope.Control.Loading = false;
                });
            };

            $scope.Control.clear = function (code) {
                if (code == '')
                    return;

                $scope.Control.Loading = true;
                ControlService.invokeCheckout($scope, $element, 'ClearGiftCard', code).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.GiftCard = '';
                    $scope.Control.GiftCardAmount = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = true;
                    $scope.Control.Result = '';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;
                    $scope.Control.Loading = false;

                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });
                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.GiftCard = '';
                    $scope.Control.GiftCardAmount = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = false;
                    $scope.Control.Result = '';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;
                    $scope.Control.Loading = false;

                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (err) {
                        $scope.Control.Loading = false;
                        throw err;
                    });
                    $scope.Control.Loading = false;
                });

            };

            $scope.Control.clearAll = function () {
                if ($scope.$parent.Order.Current.Giftcards.length == 0)
                    return;

                $scope.Control.Loading = true;
                ControlService.invokeCheckout($scope, $element, 'ClearAllGiftCards', []).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.GiftCard = '';
                    $scope.Control.GiftCardAmount = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = true;
                    $scope.Control.Result = '';

                    var data = jQuery.parseJSON(result.Data);

                    if (data && data.Message) {
                        $scope.Control.ResultMessage = data.Message;
                    }

                    $scope.Control.Loading = false;

                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });
                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.GiftCard = '';
                    $scope.Control.GiftCardAmount = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = false;
                    $scope.Control.Result = '';

                    var data = jQuery.parseJSON(result.Data);

                    if (data && data.Message) {
                        $scope.Control.ResultMessage = data.Message;
                    }

                    $scope.Control.Loading = false;

                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (err) {
                        $scope.Control.Loading = false;
                        throw err;
                    });
                    $scope.Control.Loading = false;
                });

            };

            if (checkoutOverrides && checkoutOverrides.GiftCard && typeof checkoutOverrides.GiftCard.Extend === 'function') {
                $scope = checkoutOverrides.GiftCard.Extend($scope, $element);
            }

            ControlService.getCheckoutData("GetGiftCardData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                if (checkoutOverrides && checkoutOverrides.GiftCard && typeof checkoutOverrides.GiftCard.OnGetData === 'function') {
                    checkoutOverrides.GiftCard.OnGetData($scope);
                }
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

        });
})();